import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';

if ('serviceWorker' in navigator) {
  // Clean up stale SW registered at old path before the /rep/ prefix fix
  navigator.serviceWorker.getRegistrations().then((regs) => {
    for (const reg of regs) {
      if (reg.active?.scriptURL?.endsWith('/sw.js') && !reg.active.scriptURL.endsWith('/rep/sw.js')) {
        reg.unregister();
      }
    }
  });
  navigator.serviceWorker.register('/rep/sw.js').catch(() => {});
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
